<!-- Upload indicator toggle - only visible when there are active uploads -->
<button
    *ngIf="activeCount > 0"
    mat-icon-button
    (click)="openPanel()"
    [matTooltip]="activeCount + ' upload(s) in progress'"
    #uploadsOrigin>
    <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
        <span class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-primary text-on-primary text-xs font-medium">
            {{activeCount}}
        </span>
    </span>
    <mat-icon [svgIcon]="'heroicons_outline:cloud-arrow-up'"></mat-icon>
</button>

<!-- Uploads panel -->
<ng-template #uploadsPanel>
    <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-96 sm:w-96 sm:rounded-2xl overflow-hidden shadow-lg">

        <!-- Header -->
        <div class="flex shrink-0 items-center py-4 pr-4 pl-6 bg-primary text-on-primary">
            <div class="sm:hidden -ml-1 mr-3">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
                </button>
            </div>
            <div class="text-lg font-medium leading-10">Uploads</div>
            <div class="ml-auto text-sm opacity-80">
                {{activeCount}} active
            </div>
        </div>

        <!-- Content -->
        <div class="relative flex flex-col flex-auto sm:max-h-96 divide-y overflow-y-auto bg-card">
            <!-- Uploads list -->
            <ng-container *ngFor="let upload of uploads; trackBy: trackByFn">
                <div class="flex flex-col p-4 hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5">
                    <!-- File info row -->
                    <div class="flex items-center">
                        <!-- Status icon -->
                        <mat-icon
                            class="icon-size-5 mr-3"
                            [ngClass]="getStatusColor(upload.status)"
                            [svgIcon]="getStatusIcon(upload.status)">
                        </mat-icon>

                        <!-- File name and size -->
                        <div class="flex flex-col flex-auto min-w-0">
                            <div class="font-medium truncate">{{upload.filename}}</div>
                            <div class="text-sm text-secondary">
                                {{formatFileSize(upload.uploadedBytes)}} / {{formatFileSize(upload.totalSize)}}
                            </div>
                        </div>

                        <!-- Cancel button (only for active uploads) -->
                        <button
                            *ngIf="upload.status === 'uploading' || upload.status === 'pending'"
                            mat-icon-button
                            class="ml-2"
                            [matTooltip]="'Cancel upload'"
                            (click)="cancelUpload(upload)">
                            <mat-icon class="icon-size-5 text-gray-400" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
                        </button>
                    </div>

                    <!-- Progress bar -->
                    <div *ngIf="upload.status === 'uploading'" class="mt-3">
                        <mat-progress-bar
                            [mode]="'determinate'"
                            [value]="upload.progress">
                        </mat-progress-bar>
                        <div class="flex justify-between mt-1 text-xs text-secondary">
                            <span>{{upload.progress}}%</span>
                            <span *ngIf="upload.estimatedTimeRemaining">
                                ~{{upload.estimatedTimeRemaining}}s remaining
                            </span>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- No uploads -->
            <ng-container *ngIf="!uploads || !uploads.length">
                <div class="flex flex-col flex-auto items-center justify-center py-12 px-8">
                    <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100 dark:bg-primary-800">
                        <mat-icon
                            class="text-primary-700 dark:text-primary-50"
                            [svgIcon]="'heroicons_outline:cloud-arrow-up'">
                        </mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">No uploads</div>
                    <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">
                        When you upload files, they will appear here.
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
